import api from './axiosInstance';

export const getAll = (params) => api.get('/price-change-basis', { params });
export const create = (data) => api.post('/price-change-basis', data);
export const update = (id, data) => api.put(`/price-change-basis/${id}`, data);
export const remove = (id) => api.delete(`/price-change-basis/${id}`);
